import React from "react";
import $ from "jquery";
import leftPng from "../../../../content/images/left.png";
import dateTimePng from "../../../../content/images/date-time.png";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as GC from "../../../common/common";
import { connect } from "react-redux";
import { SaveOrUpdate } from "../../../../redux/actions/catalogManagementUnitsAction";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.rowId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.rowId;
    this.state = {
      rowData: this.props.history.location.state.rowData,
      naam: this.props.history.location.state.rowData.algemeenNaam,
      code: this.props.history.location.state.rowData.algemeenCode,
      isActive: this.props.history.location.state.rowData.isActive,
      startDate: this.handleDate(
        this.props.history.location.state.rowData.startDate
      ),
      endDate: this.handleDate(
        this.props.history.location.state.rowData.endDate
      ),
      naamRequiredAlert: false,
      beginRequiredAlert: false,
      endRequiredAlert: false,
      endRequiredText: false,
      codeRequiredAlert: false,
      codeAlertText: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleDate(date) {
    var translateDate = String(date.replaceAll("-", "/"));
    translateDate =
      translateDate.split("/")[1] +
      "/" +
      translateDate.split("/")[0] +
      "/" +
      translateDate.split("/")[2];

    translateDate = new Date(translateDate);

    return GC.FormatDateReverse(translateDate, "date");
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    if (value != "" && name == "startDate") {
      this.setState({ beginRequiredAlert: false });
    }
    if (value != "" && name == "endDate") {
      this.setState({ endRequiredAlert: false });
    }
    if (value != "" && name == "naam") {
      this.setState({ naamRequiredAlert: false });
    }
  }

  handleSubmit = async () => {
    $("#cover-spin").show(0);
    //
    const { actions } = this.props;

    this.state.startDate == ""
      ? await this.setState({ beginRequiredAlert: true })
      : await this.setState({ beginRequiredAlert: false });
    this.state.endDate == ""
      ? await this.setState({
          endRequiredAlert: true,
          endRequiredText: "date entered is invalid.",
        })
      : await this.setState({ endRequiredAlert: false });

    let startDate = new Date(this.state.startDate);
    let endDate = new Date(this.state.endDate);
    if (startDate > endDate) {
      this.setState({
        endRequiredAlert: true,
        endRequiredText: "The end date cannot be smaller than the start date",
      });
    }

    var model = {
      content: {
        algemeen: {
          code: this.state.code,
          actief: this.state.isActive,
          horizon: [
            this.state.startDate + "T00:00:00.000Z",
            this.state.endDate + "T00:00:00.000Z",
          ],
          naam: this.state.naam,
        },
      },
      identification: this.rowId,
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_M_UNITS],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then(async (result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== this.rowId
        ) {
          isUnique = await false;
          $("#cover-spin").hide(0);

          alert("code is not unique");
        }
      });

    if (
      isUnique &&
      this.state.beginRequiredAlert !== true &&
      this.state.endRequiredAlert !== true &&
      this.state.naamRequiredAlert !== true &&
      this.state.codeRequiredAlert !== true
    ) {
      actions
        .SaveOrUpdate(
          model,
          "PATCH",
          this.rowId,
          window.$catalog_management_units_token
        )
        .then(() => {
          CallBackFunctions.BeheereenheidEditCallBack(
            window.$catalog_management_units_token
          );
          this.props.history.push("/catalog/management-units/");
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      $("#cover-spin").hide(0);
    }
  };

  async componentDidMount() {
    const { actions } = this.props;
  }

  render() {
    return (
      <div id="editSide" /*className="d-none"*/>
        <div className="detail-title">Beheereenheid in edit</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a
              id="detail-button"
              className="back-page-link"
              role="button"
              onClick={() => {
                this.props.history.push("/catalog/management-units");
              }}
            >
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              beheereenheden
            </a>
          </div>
          <div className="float-right mt-0">
            <a onClick={this.handleSubmit.bind(this)} className="button ok">
              Opslaan
            </a>
          </div>
          <div className="float-right mt-0 w-20">
            <a
              onClick={() => {
                this.props.history.push(
                  "/catalog/management-units/detail/" + this.rowId,
                  {
                    rowData: this.state.rowData,
                  }
                );
              }}
              className="button back"
            >
              Annuleren
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Naam Beheereenheid</div>
              <div className="box-title-2-active">
                <input
                  id="e-algemeenNaam"
                  autocomplete="off"
                  value={this.state.naam}
                  name="naam"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Code Beheereenheid</div>
              <div className="box-title-2">
                <input
                  id="e-algemeenCode"
                  autocomplete="off"
                  value={this.state.code}
                  name="code"
                  onChange={this.handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input
                  id="e-beheereenheid_active"
                  type="checkbox"
                  name="isActive"
                  onChange={this.handleInputChange}
                  checked={this.state.isActive ? true : false}
                />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-sm-6">
            <div
              className={
                this.state.beginRequiredAlert
                  ? "inp-labl modale-submit-alert-block"
                  : "inp-labl"
              }
            >
              Start horizon
            </div>
            <div
              className="inp-labl modale-submit-alert-block"
              hidden={this.state.beginRequiredAlert ? false : true}
            >
              ,{"\u00A0"}date entered is invalid.
            </div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="date"
                className="form-control inp-h inpp"
                id="e-startDate"
                value={this.state.startDate}
                name="startDate"
                onChange={this.handleInputChange}
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div
              className={
                this.state.endRequiredAlert
                  ? "inp-labl modale-submit-alert-block"
                  : "inp-labl"
              }
            >
              Eind horizon
            </div>
            <div
              className="inp-labl modale-submit-alert-block"
              hidden={this.state.endRequiredAlert ? false : true}
            >
              ,{"\u00A0"}
              {this.state.endRequiredText}
            </div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="date"
                className="form-control inp-h inpp"
                id="e-endDate"
                value={this.state.endDate}
                name="endDate"
                onChange={this.handleInputChange}
                min={this.state.startDate}
              />
            </div>
          </div>
        </div>

        <input hidden id="e-identification" />
      </div>
    );
  }
}

// export default Edit;
Edit.propTypes = {
  SaveOrUpdate: PropTypes.func.isRequired,
};
function mapStateToProps(state, ownProps) {
  return {
    catalogManagementUnits: state.rowData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      SaveOrUpdate: bindActionCreators(SaveOrUpdate, dispatch),
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
